<template>
  <div class="box">
    <img
      src="~@/assets/images/MyIntergral/rule.png"
      @click="handleJumpPage('IntegralRule')"
      alt
      class="rule"
    />
    <img
      src="~@/assets/images/MyIntergral/intetgral-detail.png"
      alt
      class="intetgral-detail x-center"
      @click="handleJumpTaskApp('2151025')"
    />
    <div class="intetgral-num-text x-center">我的积分</div>
    <div id="lll" class="intetgral-num x-center">{{ creditTotal }}</div>
    <div class="block" style="height: 37.75rem"></div>
    <div class="turntable">
      <div class="top">
        <div class="list" :class="{ activebg: bgindex == 0 }">
          <div class="img">
            <img src="~@/assets/images/MyIntergral/1.png" alt class="turntable-img" />
          </div>
          <div class="title">威露士洗手液</div>
        </div>
        <div class="list" :class="{ activebg: bgindex == 1 }">
          <div class="img">
            <img src="~@/assets/images/MyIntergral/2.png" alt class="turntable-img" />
          </div>
          <div class="title">洽洽燕麦片</div>
        </div>
        <div class="list" :class="{ activebg: bgindex == 2 }">
          <div class="img">
            <img
              src="~@/assets/images/MyIntergral/3.png"
              alt
              class="turntable-img"
              style="width:8rem;6.8rem"
            />
          </div>
          <div class="title">昆味道草鸡蛋</div>
        </div>
        <div class="list" :class="{ activebg: bgindex == 7 }">
          <div class="img">
            <img src="~@/assets/images/MyIntergral/积分.png" alt class="turntable-img1" />
          </div>
          <div class="title">30积分</div>
        </div>
        <div class="list list1" @click="choujiang">
          <div class="img" style="margin-top:0">
            <img
              src="~@/assets/images/MyIntergral/chou.png"
              alt
              class="turntable-img"
              style="width:7rem;height:6.5rem;margin-top:0"
            />
          </div>
          <div class="title1">20积分/1次</div>
        </div>
        <div class="list" :class="{ activebg: bgindex == 3 }">
          <div class="img">
            <img src="~@/assets/images/MyIntergral/积分.png" alt class="turntable-img1" />
          </div>
          <div class="title">5积分</div>
        </div>
        <div class="list" :class="{ activebg: bgindex == 6 }">
          <div class="img">
            <img
              src="~@/assets/images/MyIntergral/4.png"
              alt
              class="turntable-img"
              style="width:2.5rem"
            />
          </div>
          <div class="title">食用油</div>
        </div>
        <div class="list" :class="{ activebg: bgindex == 5 }">
          <div class="img">
            <img src="~@/assets/images/MyIntergral/积分.png" alt class="turntable-img1" />
          </div>
          <div class="title">50积分</div>
        </div>
        <div class="list" :class="{ activebg: bgindex == 4 }">
          <div class="img">
            <img src="~@/assets/images/MyIntergral/8.png" alt class="turntable-img" />
          </div>
          <div class="title">谢谢参与</div>
        </div>
      </div>
      <div class="bottom">
        <img @click="(popup3=true)" class="btnimg" src="~@/assets/images/MyIntergral/btn.png" alt />
      </div>
    </div>

    <div class="content">
      <div class="signIn card card1">
        <div class="card1-title">
          <img src="~@/assets/images/MyIntergral/每日签到.svg" alt class="mrqd" />
          <img
            src="~@/assets/images/MyIntergral/help.svg"
            @click="handleJumpPage('IntegralRule')"
            alt
            class="help-icon"
          />
          <span class="right">
            已连续签到
            <span class="num">{{ continuousCount }}</span>天
          </span>
        </div>
        <div class="card-content">
          <div class="step">
            <div
              class="step-item"
              :class="{
              active: sign === false && currentIndex == i,
              outOfDate: currentIndex > i || (sign && currentIndex == i),
            }"
              v-for="(item, i) in currentSevenList"
              :key="i"
            >
              <template>
                <div class="num" v-if="item.startsWith('第')">{{ i >= 5 ? 5 : 2 }}</div>
                <div class="num" v-else>5</div>
                <span>{{ item }}</span>
              </template>
            </div>
          </div>
          <button v-if="sign" class="is-sign">已签到</button>
          <img
            v-else
            src="~@/assets/images/MyIntergral/立即签到.svg"
            @click="handleSignIn"
            alt
            class="btn"
          />
        </div>
      </div>
      <div class="card card2">
        <div class="card-title">
          <img src="~@/assets/images/MyIntergral/新手任务.png" alt class="card-title-img" />
        </div>
        <div class="card-list">
          <div
            class="item"
            v-show="
            item.taskName === '用户L2认证' ||
            item.taskName === '用户L3认证' ||
            item.taskName === '用户L4认证'
          "
            :key="i"
            v-for="(item, i) in NewbieTask"
          >
            <div class="img">
              <img
                v-show="item.taskId === '22100811414363500016'"
                src="~@/assets/images/MyIntergral/icon1.png"
                alt
              />
              <img
                v-show="item.taskId === '22100811421007100017'"
                src="~@/assets/images/MyIntergral/icon2.png"
                alt
              />
              <img
                v-show="item.taskId === '22100811423480400018'"
                src="~@/assets/images/MyIntergral/icon3.png"
                alt
              />
            </div>
            <div class="label">
              <div class="item-title">{{ item.taskName }}</div>
              <div class="item-add-intergal">
                <span class="num">
                  +{{
                  item.taskName === "用户L2认证"
                  ? 2
                  : item.taskName === "用户L3认证"
                  ? 3
                  : 10
                  }}
                </span>积分
              </div>
            </div>
            <div
              class="btn"
              v-if="item.restrictOn === 2 && item.completionCount === 1"
              style="background: rgba(252, 153, 39, 0.7)"
            >已完成</div>
            <div class="btn" @click="handleJumpTaskApp('2151021')" v-else>去完成</div>
          </div>
          <div class="item more-btn" @click="popup1 = true">查看全部任务</div>
        </div>
      </div>
      <div class="card card2">
        <div class="card-title">
          <img src="~@/assets/images/MyIntergral/日常任务.png" alt class="card-title-img" />
        </div>
        <div class="card-list">
          <div class="item" v-for="(item, i) in DailyTasks" :key="i" v-show="i < 3">
            <div class="img">
              <img
                :src="
                imgList.filter((sub_item) => sub_item.taskId === item.taskId)
                  .length === 1
                  ? imgList.filter(
                    (sub_item) => sub_item.taskId === item.taskId
                  )[0].imgUrl
                  : ''
              "
                alt
              />
            </div>
            <div class="label">
              <div class="item-title">
                <span style="margin-left: -0.375rem">{{ item.taskName }}</span>
                <span class="num">{{ item.completionCount }}/{{ item.restrictNum }}</span>
              </div>
              <div class="item-add-intergal">
                <span class="num">+{{ item.taskName | filterTaskIntegral }}</span>积分
                <span
                  v-if="
                  item.restrictNum > 1 ||
                  item.taskId === '22101916553296405908'
                "
                >
                  /{{
                  item.taskId === "22101916553296405908" ? "笔订单" : "次"
                  }}
                </span>
              </div>
            </div>
            <div style="display: flex; flex-direction: column; align-items: center">
              <div
                class="btn"
                v-if="
                item.restrictType === 0 &&
                item.completionCount === item.restrictNum
              "
                style="background: #ffeee2; color: #ff6b01"
              >明日再来</div>
              <div
                class="btn"
                v-else-if="
                item.restrictType === 1 &&
                item.completionCount === item.restrictNum
              "
                style="background: #ffeee2; color: #ff6b01"
              >已完成</div>
              <div
                class="btn"
                v-else-if="item.restrictOn === 2 && item.completionCount !== 0"
                style="background: #ffeee2; color: #ff6b01"
              >已完成</div>
              <div class="btn" @click="handleJumpTaskApp(item.appId)" v-else>去完成</div>
              <span
                v-if="
                item.restrictType === 0 &&
                item.restrictOn !== 0 &&
                item.restrictNum !== 1
              "
                style="
                  display: block;
                  color: #ff6b01;
                  font-size: 1.5rem;
                  margin-top: 0.5rem;
                "
              >(一天限{{ item.restrictNum }}次)</span>
            </div>
          </div>
          <div class="item more-btn" @click="popup2 = true">查看全部任务</div>
        </div>
      </div>
    </div>

    <van-popup v-model="popup1" position="bottom" round>
      <div class="popup">
        <div class="card card2">
          <div class="card-title">
            <img src="~@/assets/images/MyIntergral/新手任务.png" alt class="card-title-img" />
          </div>
          <div class="card-list">
            <div
              class="item"
              v-show="
              item.taskName === '用户L2认证' ||
              item.taskName === '用户L3认证' ||
              item.taskName === '用户L4认证'
            "
              :key="i"
              v-for="(item, i) in NewbieTask"
            >
              <div class="img">
                <img
                  v-show="item.taskId === '22100811414363500016'"
                  src="~@/assets/images/MyIntergral/icon1.png"
                  alt
                />
                <img
                  v-show="item.taskId === '22100811421007100017'"
                  src="~@/assets/images/MyIntergral/icon2.png"
                  alt
                />
                <img
                  v-show="item.taskId === '22100811423480400018'"
                  src="~@/assets/images/MyIntergral/icon3.png"
                  alt
                />
              </div>
              <div class="label">
                <div class="item-title">{{ item.taskName }}</div>
                <div class="item-add-intergal">
                  <span class="num">
                    +{{
                    item.taskName === "用户L2认证"
                    ? 2
                    : item.taskName === "用户L3认证"
                    ? 3
                    : 10
                    }}
                  </span>积分
                </div>
              </div>
              <div
                class="btn"
                v-if="item.restrictOn === 2 && item.completionCount === 1"
                style="background: rgba(252, 153, 39, 0.7)"
              >已完成</div>
              <div class="btn" @click="handleJumpTaskApp('2151021')" v-else>去完成</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="popup2" position="bottom" round>
      <div class="popup">
        <div class="card card2">
          <div class="card-title">
            <img src="~@/assets/images/MyIntergral/日常任务.png" alt class="card-title-img" />
          </div>
          <div class="card-list">
            <div class="item" v-for="(item, i) in DailyTasks" :key="i">
              <div class="img">
                <img
                  :src="
                  imgList.filter(
                    (sub_item) => sub_item.taskId === item.taskId
                  ).length === 1
                    ? imgList.filter(
                      (sub_item) => sub_item.taskId === item.taskId
                    )[0].imgUrl
                    : ''
                "
                  alt
                />
              </div>
              <div class="label">
                <div class="item-title">
                  <span style="margin-left: -0.375rem">{{ item.taskName }}</span>
                  <span
                    class="num"
                    v-if="item.restrictOn !== 0"
                  >{{ item.completionCount }}/{{ item.restrictNum }}</span>
                </div>
                <div class="item-add-intergal">
                  <span class="num">+{{ item.taskName | filterTaskIntegral }}</span>积分
                  <span
                    v-if="
                    item.restrictNum > 1 ||
                    item.taskId === '22101916553296405908'
                  "
                  >
                    /{{
                    item.taskId === "22101916553296405908" ? "笔订单" : "次"
                    }}
                  </span>
                </div>
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <div
                  class="btn"
                  v-if="
                  item.restrictType === 0 &&
                  item.completionCount === item.restrictNum &&
                  item.restrictOn === 1
                "
                  style="background: #ffeee2; color: #ff6b01"
                >明日再来</div>
                <div
                  class="btn"
                  v-else-if="
                  item.restrictType === 1 &&
                  item.completionCount === item.restrictNum &&
                  item.restrictOn === 1
                "
                  style="background: #ffeee2; color: #ff6b01"
                >已完成</div>
                <div
                  class="btn"
                  v-else-if="
                  item.restrictOn === 2 && item.completionCount !== 0
                "
                  style="background: #ffeee2; color: #ff6b01"
                >已完成</div>
                <div class="btn" @click="handleJumpTaskApp(item.appId)" v-else>去完成</div>
                <span
                  v-if="
                  item.restrictType === 0 &&
                  item.restrictOn !== 0 &&
                  item.restrictNum !== 1
                "
                  style="
                    display: block;
                    color: #ff6b01;
                    font-size: 1.5rem;
                    margin-top: 0.5rem;
                  "
                >(一天限{{ item.restrictNum }}次)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-dialog v-model="isJLShow" :showConfirmButton="false">
      <img
        src="~@/assets/images/MyIntergral/close.svg"
        @click="(isJLShow = false)"
        class="close"
        alt
      />
      <div class="msg">
        <img src="~@/assets/images/MyIntergral/zhongjiang.png" alt />
      </div>
      <div class="text">恭喜您</div>
      <div class="text1">抽中了“{{ JPtitle }}”</div>
      <div class="bottom">
        <div class="btn" @click="(isJLShow = false)">开心收下</div>
      </div>
    </van-dialog>
    <van-dialog v-model="noShow" :showConfirmButton="false">
      <div class="msg1">
        <img src="~@/assets/images/MyIntergral/8.png" alt />
      </div>
      <div class="text">谢谢参与</div>
      <div class="text1">您没有中奖</div>
      <div class="bottom">
        <div class="btn" @click="(noShow = false)">再来一次</div>
      </div>
    </van-dialog>
    <van-dialog v-model="popup3" :showConfirmButton="false"  class="page" round>
      <img src="~@/assets/images/MyIntergral/close.svg" @click="(popup3 = false)" class="close" alt />
      
      <ul v-if="(zjdata.length>0)">
        <li class="list" v-for="(item,index) in zjdata" :key="index" >
          <div class="img">
            <img :src="item.imgurl" alt />
          </div>
          
          <div class="bottom">
            <div class="title">获得“{{item.title}}”</div>
            <div class="time">{{formTime(item.date)}}</div>
          </div>
        </li>
      </ul>
      <div class="pox" v-else>
        <img src="~@/assets/images/MyIntergral/empye.png" alt="">
        <div class="title2">暂无记录</div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { Field, Toast } from "vant";
import { Dialog } from "vant";
import bridge from "../../common/bridge.js";
export default {
  data() {
    return {
      // 签到
      a: 0,
      JPtitle: "",
      isJLShow: false,
      noShow: false,
      signPage: 1,
      isOpen: false,
      timer: null,
      currentDayIndex: 0,
      isAndroid: false,
      isiOS: false,
      popup1: false,
      popup2: false,
      isLoading: false,
      creditTotal: 0,
      sign: false,
      continuousCount: 0,
      NewbieTask: [],
      DailyTasks: [],
      popup3: false,
      bgindex: 8,
      listdata: [
        {
          title: "威露士洗手液",
          imgurl: require("@/assets/images/MyIntergral/1.png")
        },
        {
          title: "洽洽燕麦片",
          imgurl: require("@/assets/images/MyIntergral/2.png")
        },
        {
          title: "昆味道草鸡蛋",
          imgurl: require("@/assets/images/MyIntergral/3.png")
        },

        {
          title: "5积分",
          imgurl: require("@/assets/images/MyIntergral/积分.png"),
          num: 5
        },
        {
          title: "谢谢参与",
          imgurl: require("@/assets/images/MyIntergral/8.png")
        },
        {
          title: "50积分",
          imgurl: require("@/assets/images/MyIntergral/积分.png"),
          num: 50
        },

        {
          title: "食用油",
          imgurl: require("@/assets/images/MyIntergral/4.png")
        },
        {
          title: "30积分",
          imgurl: require("@/assets/images/MyIntergral/积分.png"),
          num: 30
        }
      ],
      zjdata: [
     
      ],
      // 正式
      imgList: [
        {
          taskId: "22101014152593905945",
          imgUrl: require("@/assets/images/MyIntergral/icon4.png")
        },
        {
          taskId: "22101114365544409449",
          imgUrl: require("@/assets/images/MyIntergral/icon6.png")
        },
        {
          taskId: "22101114363358201974",
          imgUrl: require("@/assets/images/MyIntergral/icon5.png")
        },
        {
          taskId: "22101916534837909333",
          imgUrl: require("@/assets/images/MyIntergral/market.png")
        },
        {
          taskId: "22101221155208200493",
          imgUrl: require("@/assets/images/MyIntergral/card.png")
        },
        {
          taskId: "22102010053391107663",
          imgUrl: require("@/assets/images/MyIntergral/article.png")
        },
        {
          taskId: "22102010061837406359",
          imgUrl: require("@/assets/images/MyIntergral/share.png")
        },
        {
          taskId: "22101916553296405908",
          imgUrl: require("@/assets/images/MyIntergral/shopping.png")
        },
        {
          taskId: "22100914002461507564",
          imgUrl: require("@/assets/images/MyIntergral/epidemic situation.png")
        },
        {
          taskId: "22110915401912909055",
          imgUrl: require("@/assets/images/MyIntergral/services robot.png")
        },
        {
          taskId: "22100811380590500015",
          imgUrl: require("@/assets/images/MyIntergral/icon2.png")
        },
        {
          taskId: "22100811353112800014",
          imgUrl: require("@/assets/images/MyIntergral/icon1.png")
        }
      ],
      handleJumpTaskAppTimer: null,
      // 测试
      // imgList: [
      //   { taskId: "22101915443236100001", imgUrl: require('@/assets/images/MyIntergral/share.png') },
      //   { taskId: "22101915440820000000", imgUrl: require('@/assets/images/MyIntergral/article.png') },
      //   { taskId: "22101809481388100002", imgUrl: require('@/assets/images/MyIntergral/market.png') },
      //   { taskId: "22102614012608000141", imgUrl: require('@/assets/images/MyIntergral/time.png') },
      //   { taskId: "22102614031305500142", imgUrl: require('@/assets/images/MyIntergral/services robot.png') },
      //   { taskId: "22093017490837100001", imgUrl: require('@/assets/images/MyIntergral/epidemic situation.png') },
      // ]
      currentSevenList: [],
      currentIndex: 1
      // time0:0
    };
  },

  filters: {
    filterTaskIntegral(taskName) {
      let count;
      switch (taskName) {
        case "使用10分钟":
        case "商城购物积分":
          count = 2;
          break;
        default:
          count = 1;
          break;
      }
      return count;
    }
  },
  mounted() {
    this.init();
    // this.timer = setInterval(() => this.init(), 1000);
  },

  watch: {
    creditTotal: function(val) {
      clearInterval(this.timer);
    }
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    // 初始化函数
    async init() {
      await this.getCreditColumnlist();

      await this.getUserCreditInfo();
      await this.getEquipmentType();
      await this.isSignIn();
    },
    choujiang() {
      // console.log(123);
      if (this.creditTotal < 20) {
        Dialog.alert({
          message: "你的积分余额不足"
        }).then(() => {});
        return;
      }
      if (this.a == 1) {
        console.log(123);
        // clearInterval(timer)
        return;
      }
      this.creditTotal = this.creditTotal - 20;

      // console.log();
      let time0 = 0;
      let timer = setInterval(() => {
        this.a = 1;
        // console.log(a);
        let index = Math.floor(Math.random() * 8 + 0);
        this.bgindex = index;
        // console.log(this.bgindex);
        time0++;
        if (time0 == 15) {
          // console.log(this.bgindex);

          clearInterval(timer);
          this.a = 0;
          if (this.bgindex == 3 || this.bgindex == 7 || this.bgindex == 5) {
            this.creditTotal =
              this.creditTotal + this.listdata[this.bgindex].num;
            // console.log(this.creditTotal);
          }
          if (this.bgindex == 4) {
            this.noShow = true;
          } else {
            this.listdata.forEach((item,index)=>{
              if(index==this.bgindex){
                item.date=new Date()
                this.zjdata.unshift(item)
              }
            })
            this.JPtitle = this.listdata[this.bgindex].title;
            this.isJLShow = true;
          }
        }
      }, 200);
    },
    // 获取当前天数的索引
    getCurrentDayIndex(continuousCount, signPage) {
      for (let i = 1; i < 8; i++) {
        if (
          new Date().getDate() + i - (continuousCount - 7 * signPage) - 1 ===
          new Date().getDate()
        ) {
          this.currentDayIndex = i;
        }
      }
    },
    formTime(date){
      // date=new Date()
      console.log(date);
      console.log(date.getMonth());
      var y = date.getFullYear()
      var m = date.getMonth()+1
      var d = date.getDate()
      var h = date.getHours()
      var i = date.getMinutes()
      if(m<10){
        m='0'+m
      }
      if(d<10){
        d='0'+d
      }
      if(h<10){
        h='0'+h
      }
      if(i<10){
        i='0'+i
      } 
      return y+'-'+m+'-'+d+' '+h+':'+i
    },
    // 获取设备类型
    getEquipmentType() {
      let ua = navigator.userAgent;
      this.isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      this.isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },

    // app跳转
    handleJumpTaskApp(appId) {
      // this.timer = setInterval(() => this.init(), 2000);
      console.log(appId);
      // return;
      this.isOpen = true;
      let self = this;
      if (appId === "当前应用暂不支持") {
        Dialog.alert({
          message: "当前应用暂不支持点击跳转"
        }).then(() => {});
        return;
      }
      if (this.handleJumpTaskAppTimer != null) return;
      this.handleJumpTaskAppTimer = setTimeout(() => {
        clearTimeout(this.handleJumpTaskAppTimer);
        this.handleJumpTaskAppTimer = null;
      }, 500);
      if (
        appId === "2151022" ||
        appId === "2151021" ||
        appId === "2151023" ||
        appId === "2151024" ||
        appId === "2151025"
      ) {
        if (this.isAndroid) {
          console.log(1);
          window["refreshH5"] = function() {
            self.refreshH5();
          };
          window.ServiceAddrInterface.jumpNativeApp(appId);
          return;
        } else {
          bridge.registerhandler("refreshH5", function() {
            self.refreshH5();
          });
          bridge.callhandler("jumpNativeApp", appId, data => {
            console.log(data);
          });
          return;
        }
      }

      if (this.isAndroid) {
        window["refreshH5"] = function() {
          self.refreshH5();
        };
        window.ServiceAddrInterface.openApp(appId);
        return;
      }
      if (this.isiOS) {
        bridge.registerhandler("refreshH5", function() {
          self.refreshH5();
        });
        bridge.callhandler("openApp", appId, data => {
          console.log(data);
        });
        return;
      }
    },

    refreshH5() {
      if (this.isOpen) {
        this.isOpen = false;
        this.init();
      }
    },

    // 页面跳转
    handleJumpPage(name) {
      this.$router.push({ name });
    },

    // 判断是否签到
    async isSignIn() {
      Toast.loading({
        message: "请等待...",
        forbidClick: true
      });
      await this.$axios
        .post("/cityuserinfo/user/integral/isSignIn?t=" + new Date().getTime())
        .then(res => {
          Toast.clear();
          this.isLoading = false;
          let {
            result,
            currentCredit,
            continuousCount,
            sign,
            reason: message
          } = res.data;
          if (result === 1) {
            this.creditTotal = currentCredit;
            this.sign = sign;
            this.continuousCount = continuousCount;
            this.signPage = Math.floor(this.continuousCount / 7);

            let num = this.sign ? -1 : 0;
            this.currentIndex = (this.continuousCount + num) % 7;
            if (this.continuousCount <= 7) {
              this.currentSevenList = [
                "第1天",
                "第2天",
                "第3天",
                "第4天",
                "第5天",
                "第6天",
                "第7天"
              ];
            } else {
              let startDate =
                new Date().getTime() - this.currentIndex * 1000 * 60 * 60 * 24;
              for (let index = 0; index < 7; index++) {
                this.currentSevenList.push(
                  new Date(startDate + index * 1000 * 60 * 60 * 24).format(
                    "MM.dd"
                  )
                );
              }
            }
            this.currentSevenList[this.currentIndex] = this.sign ? "今天" : "";

            this.getCurrentDayIndex(this.continuousCount, this.signPage);
          } else {
            Dialog.alert({
              message
            });
            return;
          }
        })
        .catch(err => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败"
          }).then(() => {});
          return;
        });
    },

    // 签到
    handleSignIn() {
      Toast.loading({
        message: "请等待...",
        forbidClick: true
      });
      this.$axios
        .post("/cityuserinfo/user/integral/signIn")
        .then(res => {
          console.log(res);
          Toast.clear();
          if (res.data.result === 1) {
            this.isSignIn();
          } else {
            Dialog.alert({
              message: res.data.reason
            }).then(() => {});
            return;
          }
        })
        .catch(err => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败"
          }).then(() => {});
          return;
        });
    },

    // 获取积分记录
    getUserCreditInfo() {
      Toast.loading({
        message: "请等待...",
        forbidClick: true
      });
      this.$axios
        .post("/creditcenter/user/getUserCreditInfo")
        .then(res => {
          Toast.clear();
          if (res.data.result === 1) {
            this.creditTotal = res.data.data.creditTotal;
          } else {
            Dialog.alert({
              message: res.data.reason
            }).then(() => {});
            return;
          }
        })
        .catch(err => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败"
          }).then(() => {});
          return;
        });
    },

    // 查询积分栏目列表
    async getCreditColumnlist() {
      Toast.loading({
        message: "请等待...",
        forbidClick: true
      });
      let CreditColumnlist = await this.$axios
        .post("/creditcenter/getCreditColumnlist")
        .catch(err => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败"
          }).then(() => {});
          return;
        });
      if (CreditColumnlist.data.result === 1) {
        CreditColumnlist.data.data.forEach(item => {
          this.getUserCreditColumnTasklist(item.columnCode);
        });
      }
      Toast.clear();
    },

    // 获取用户任务完成信息
    async getUserCreditColumnTasklist(columnCode) {
      let data = new URLSearchParams();
      data.append("columnCode", columnCode);
      await this.$axios
        .post("/creditcenter/user/getUserCreditColumnTasklist", data)
        .then(res => {
          Toast.clear();
          if (res.data.result === 1) {
            if (res.data.data.columnName === "新手任务") {
              res.data.data.list.map(
                item => (item.appId = this.getAppId(item.taskId))
              );
              this.NewbieTask = res.data.data.list.reverse();
            }
            if (res.data.data.columnName === "日常任务") {
              let arr = [];
              res.data.data.list.forEach(item => {
                item.appId = this.getAppId(item.taskId);
                if (item.taskId !== "22100811304081800012") {
                  arr.push(item);
                }
              });
              this.DailyTasks = arr;
            }
          } else {
            Dialog.alert({
              message: res.data.reason
            }).then(() => {});
            return;
          }
          // this.NewbieTask = JSON.parse(this.Decrypt(res.data.data)).list
        })
        .catch(err => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败"
          }).then(() => {});
          return;
        });
    },

    // 获取应用id 测试
    // getAppId(taskId) {
    //   let appId = "当前应用暂不支持"
    //   switch (taskId) {
    //     case "22101915443236100001":
    //       appId = 'I21072100101545902449'
    //       break
    //     case "22101915440820000000":
    //       appId = 'I21072100101545902449'
    //       break
    //   }
    //   return appId
    // },

    // 获取应用id 正式
    getAppId(taskId) {
      let appId = "当前应用暂不支持";
      switch (taskId) {
        case "22101114365544409449":
          appId = "I21042316351238800001";
          break;
        case "22101114363358201974":
          appId = "I21042316351238800001";
          break;
        case "22101221155208200493":
          appId = "I21042316343988800000";
          break;
        case "22101014152593905945":
          appId = "I21060922274262600001";
          break;
        case "22102010053391107663":
        case "22102010061837406359":
          appId = "I21052911110465400007";
          break;
        case "22101916534837909333":
        case "22101916553296405908":
          appId = "I22080809534738300248";
          break;
        case "22100811380590500015":
        case "22100811353112800014":
          appId = "2151022";
          break;
        case "22110915401912909055":
          appId = "2151023";
          break;
        case "22100914002461507564":
          appId = "2151024";
          break;
      }
      return appId;
    }
  }
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.x-center {
  left: 50%;
  transform: translateX(-50%);
}

.y-center {
  left: 50%;
  transform: translateY(-50%);
}

.box {
  position: relative;
  min-height: 100vh;
  background: url("~@/assets/images/MyIntergral/head.png") no-repeat top/100%,
    url("~@/assets/images/MyIntergral/bg.png") no-repeat 0 44.63rem/100%,
    #fffff1;

  .rule {
    position: absolute;
    width: 4.75rem;
    height: 4.75rem;
    left: 40.88rem;
    top: 2.13rem;
  }
.page{
  background: url("~@/assets/images/MyIntergral/0.png") no-repeat;
  background-size: cover;
  padding-top: 8rem;
  width: 43rem;
  min-height: 61rem;
  .close{
    position: absolute;
    right: 2rem;
    top: 7rem;
  }
  ul{
    padding:0 4rem;
    overflow: auto;
    width: 100%;
    height: 49rem;
  }
  .list{
    padding: 1rem 1rem;
    display: flex;
    // margin-bottom: 1rem;
    // background: #c7c7c7;
    border-bottom: 1px solid #EAEAEA;
    .img{
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 4rem;
        height: 4rem;
      }
    }
    .bottom{
      padding: 1rem 2rem;
      margin-top: 0;
      display: block;
      .title{
        white-space: pre-wrap;
    word-break: break-all;
    color: #19212a;
    font-size: 2rem;
    font-weight: 600;
      }
      .time{
        color: #888;
        font-size: 1.5rem;
        margin-top: 1rem;
      }
    }
  }
  .pox{
    padding: 8rem 0;
    text-align: center;
    img{
      width: 20rem;
    }
    .title2{
      color: #19212A;
      font-size: 2.1rem;
    }
  }
}
  .turntable {
    background: url("~@/assets/images/MyIntergral/bgtop.png") no-repeat;
    background-size: cover;
    width: 100%;
    padding: 0 2.7rem;

    .top {
      padding: 3.25rem 2.5rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .list {
        padding: 1rem;
        border-radius: 0.8rem;
        background: linear-gradient(180deg, #e9fff6 0%, #ffffff 100%);
        margin-top: 1.4rem;
        width: 11.25rem;
        height: 11.25rem;

        .img {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 0.5rem;
        }

        .turntable-img {
          width: 6rem;
          height: 6rem;
        }

        .turntable-img1 {
          width: 6rem;
          height: 6rem;
          margin-left: 1.4rem;
        }

        .title {
          font-size: 1.2rem;
          color: #23787c;
          margin-top: 0.4rem;
          text-align: center;
        }

        .title1 {
          font-size: 1.2rem;
          color: #6f3b1d;
          margin-top: 0.4rem;
          text-align: center;
        }
      }

      .list1 {
        background: linear-gradient(143.68deg, #ffd363 11.07%, #fc8c4a 79.92%);
        border: 1px solid #fff1dc;
        box-shadow: inset 0px 3px 12px #ffe481;
      }

      .activebg {
        background: rgb(28 7 7 / 23%);
      }
    }

    .bottom {
      height: 16.3rem;
      text-align: center;
      padding-top: 6.5rem;

      .btnimg {
        width: 26.25rem;
        height: 7rem;
      }
    }
  }

  .intetgral-detail {
    position: absolute;
    width: 11.75rem;
    height: 4rem;
    top: 17.25rem;
    box-shadow: 0rem 0rem 0.75rem #2ab596;
    border-radius: 2rem;
  }

  .intetgral-num-text {
    position: absolute;
    top: 7.88rem;

    font-weight: 500;
    font-size: 2rem;

    color: #555555;
  }

  .intetgral-num {
    color: #ff7f00;
    font-weight: 700;
    font-size: 4.75rem;
    position: absolute;
    top: 11rem;
    text-align: center;
  }

  .content {
    padding: 0 2rem;
    margin-top: 1rem;
  }

  .card {
    border: 0.75rem solid rgba(10, 177, 137, 1);
    border-radius: 2.25rem;
    margin-bottom: 1.63rem;
    width: 100%;

    background: #fffbfb;
    box-shadow: inset 0rem 0rem 1rem #b9f6f4;
    backdrop-filter: blur(2.75rem);

    .card-title {
      text-align: center;
      margin-top: -0.75rem;

      .card-title-img {
        width: 29.63rem;
        height: 5.44rem;
      }
    }

    .card-list {
      padding: 1.56rem 2.13rem 2.5rem 2.13rem;

      //   max-height: 50rem;
      //   overflow: auto;
      .item {
        width: 100%;
        height: 10rem;
        display: flex;
        align-items: center;

        border-bottom: 0.13rem solid #eaeaea;

        &:last-child {
          border: none;
        }

        .img {
          width: 4rem;
          height: 4rem;
          margin-right: 2rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .label {
          flex: 1;
          display: flex;
          flex-direction: column;
          white-space: nowrap;

          .item-title {
            // display: flex;
            // flex-wrap: wrap;
            white-space: pre-wrap;
            word-break: break-all;
            color: #19212a;
            font-size: 2rem;
            font-weight: 600;
          }

          .item-add-intergal {
            margin-top: 0.75rem;
            font-size: 1.5rem;
            color: rgba(135, 135, 135, 1);
          }
        }

        span.num {
          color: #ff6b01;
          margin-right: 0.38rem;
          font-weight: 400;
          font-size: 1.5rem;
        }

        .btn-box {
          display: flex;
          flex-direction: column;
          align-items: center;

          .num {
            margin-top: 0.5rem;
          }
        }

        .btn {
          width: 9rem;
          height: 4rem;
          font-size: 1.88rem;
          font-weight: 500;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(90deg, #17a589 0%, #0d8d7d 100%);
          border-radius: 2rem;
        }
      }

      .more-btn {
        display: block;

        background: rgba(30, 157, 137, 0.1);
        border-radius: 2.5rem;
        width: 27.13rem;
        height: 5rem;
        line-height: 5rem;
        margin: 2.13rem auto 0 auto;

        color: #338989;
        font-weight: 400;
        font-size: 2rem;
        text-align: center;
      }
    }
  }

  .card1 {
    height: 25.63rem;
    padding: 1.92rem 2rem 2.13rem 1.63rem;

    .card1-title {
      display: flex;

      .mrqd {
        width: 9.99rem;
        // height: 1.98rem;
        flex-shrink: 0;
      }

      .help-icon {
        width: 1.88rem;
        // height: 1.88rem;
        margin-left: 0.38rem;
        flex-shrink: 0;
      }

      .right {
        flex: 1;
        text-align: right;
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 400;
        font-size: 1.63rem;
        color: #878787;

        .num {
          color: #ff6b01;
          margin: 0 0.5rem;
        }
      }
    }

    .card-content {
      display: flex;
      flex-direction: column;
      margin-top: 2.23rem;

      .step {
        height: 8.5rem;
        width: 100%;
        display: flex;

        .step-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 4.88rem;
          height: 8.5rem;
          margin-left: 0.63rem;
          text-align: center;

          &:last-child {
            margin-left: none;
          }

          .num {
            width: 3.67rem;
            height: 3.67rem;
            // line-height: 3.67rem;
            color: #ff6b01;
            font-weight: 900;
            font-size: 2rem;
            background: url("~@/assets/images/MyIntergral/step-num.png");
            background-size: 100% 100%;
            margin-top: 0.75rem;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          span {
            flex: 1;
            margin-top: 0.75rem;
            color: #878787;
            font-size: 1.5rem;
            display: inline-block;
          }
        }

        .outOfDate {
          background: url("~@/assets/images/MyIntergral/outOfDate.png");
          background-size: 100% 100%;

          span {
            display: inline-block;
            margin-top: 5.25rem;
            color: #ffffff;
            // opacity: 0.5;
            font-size: 1.5rem;
          }

          .num {
            display: none;
          }
        }

        .active {
          background: url("~@/assets/images/MyIntergral/step-active.png");
          background-size: 100% 100%;

          .num {
            display: none;
          }
        }
      }

      .btn {
        width: 22.88rem;
        margin: 1.88rem auto 0 auto;
        display: block;
      }
    }
  }

  .popup {
    background: linear-gradient(180deg, #ffffff 0%, #dffffc 100%);
    padding: 3.63rem 2rem 2.5rem 2rem;

    .card-list {
      max-height: 60vh;
      min-height: 30vh;
      overflow: auto;
    }

    &::after {
      content: "";
      width: 11.25rem;
      border-top: 0.5rem solid #c7c7c7;
      display: block;
      position: absolute;
      top: 1.38rem;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.van-dialog {
  padding: 2.5rem 0 3.75rem;
  background: #fff6e6;
  .close {
    position: absolute;
    right: 2rem;
    top: 2rem;
  }
  .msg {
    padding-left: 14rem;

    img {
      width: 13rem;
      height: 10.5rem;
    }
  }
  .msg1 {
    text-align: center;
  }
  .text {
    color: #ff6b01;
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 41px;
    text-align: center;
  }

  .text1 {
    font-style: normal;
    margin-top: 0.5rem;
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    /* identical to box height */
    color: #ff6b01;

    text-align: center;
  }

  .bottom {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
  }

  .btn {
    width: 22.875rem;
    height: 5.5rem;
    background: linear-gradient(
      180deg,
      #fddf33 0%,
      #ff9c29 67.75%,
      #f99726 83.37%,
      #fea640 100%
    );
    box-shadow: inset 0px 0px 4px #ffefd4;
    border-radius: 22px;
    text-align: center;
    line-height: 5.5rem;
    font-weight: 700;
    font-size: 19px;
    // line-height: 28px;
    /* identical to box height */

    color: #fffcf7;
  }
}

.is-sign {
  margin: 0 auto;
  background: linear-gradient(
    180deg,
    #fddf33 0%,
    #ff9c29 67.75%,
    #f99726 83.37%,
    #fea640 100%
  );
  box-shadow: inset 0px 0px 4px #ffefd4;
  border-radius: 22px;
  border: none;
  padding: 1rem 6.75rem;
  margin-top: 1.75rem;
  font-size: 2.375rem;
  font-weight: 700;
  color: #fff;
}
</style>